import type { EChartsCoreOption } from 'echarts/core';
import { useEffect, useState } from 'react';

const reducedMotionQuery = '(prefers-reduced-motion: reduce)';

export function applyChartMotionPreference(option: EChartsCoreOption, reduced: boolean) {
  if (!reduced) return option;
  return {
    ...option,
    animation: false,
    animationDuration: 0,
    animationDurationUpdate: 0,
  } as EChartsCoreOption;
}

export function useReducedMotionPreference() {
  const [reduced, setReduced] = useState(
    () => typeof window !== 'undefined' && window.matchMedia?.(reducedMotionQuery).matches,
  );

  useEffect(() => {
    if (!window.matchMedia) return;
    const media = window.matchMedia(reducedMotionQuery);
    const update = () => setReduced(media.matches);
    media.addEventListener('change', update);
    update();
    return () => media.removeEventListener('change', update);
  }, []);

  return reduced;
}
